import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

import { gradientBackgrounds } from "@/components/AIComponents/AiComponents.style";

const { heading4Obj } = typographyStyles;
const { colors } = constants;
const white = colors.ui.white[500];

export const containerWrapperCss: CSSObject = {
  position: "relative",
  padding: "16px",
  minWidth: "940px",
  background: gradientBackgrounds[100],
  borderRadius: "16px",
  height: "100%",
  overflowX: "hidden",
  overflowY: "auto",
};

export const previewContainerCss: CSSObject = {
  width: "100%",
  minHeight: "100%",
  background: white,
};

export const templateContainerCss: CSSObject = {
  width: "100%",
};

export const templateFormCss: CSSObject = {
  width: "100%",
};

export const previewHeaderTextStyles: CSSObject = {
  ...heading4Obj,
  margin: "5px 0 12px",
};

export const previewHeaderActionsStyles: CSSObject = {
  position: "absolute",
  inset: "24px 24px auto auto",
};
